import React from 'react';
import './sciqusbanner.scss'
import SciqusLogo from '../../assest/group7.png'
import bannerphoto from '../../assest/bannerphoto200kb.png'

const BG_IMAGE_URL = bannerphoto;

const Sciqusbanner = () => {
	return (
		<div className="mainSciqusbanner">
			<div className="subSciqusbanner">
				<img
					className="sciqusbannerImage"
					src={BG_IMAGE_URL}
					alt="Team collaborating in office"
				/>
				<div className="subSciqusbannerShowColor"></div>
				<div className="sciqusbanner">
					<h1 className="sciqusbannerheading">
						Redefine the Future of Account
						<br/>
						Management with
					</h1>
					<div className="LogoImage">
						<img src={SciqusLogo} alt=""/>
					</div>
					<div className="SciqusTagLine">
						<p>
							World's first end-to-end AI-powered
							<br/>
							<strong>Account Management Solution</strong>
						</p>
					</div>
				</div>
			</div>
			
			
			{/*/!* Pink-to-purple gradient overlay *!/*/}
			{/*<div className="sciqus-banner__overlay"/>*/}
			
			{/*/!* Main content *!/*/}
			{/*<div className="sciqus-banner__content">*/}
			{/*	/!* Heading *!/*/}
			{/*	<h1 className="sciqus-banner__heading">*/}
			{/*		Redefine the Future of Account*/}
			{/*		<br/>*/}
			{/*		Management with*/}
			{/*	</h1>*/}
			{/*	*/}
			{/*	/!* Logo pill *!/*/}
			{/*	<div className="sciqus-banner__logo-box">*/}
			{/*          <span className="sciqus-banner__logo-text">*/}
			{/*            <span className="sci">sci</span>*/}
			{/*            <span className="qus">qus</span>*/}
			{/*            <span className="space"/>*/}
			{/*            <span className="ams">ams</span>*/}
			{/*            <span className="tm">™</span>*/}
			{/*          </span>*/}
			{/*	</div>*/}
			{/*	*/}
			{/*	/!* Tagline *!/*/}
			{/*	<p className="sciqus-banner__tagline">*/}
			{/*		World's first end-to-end AI-powered*/}
			{/*		<br/>*/}
			{/*		Account Management Solution*/}
			{/*	</p>*/}
			{/*</div>*/}
		</div>
	);
};

export default Sciqusbanner;